import { Component, inject, OnInit, effect } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TenantConfigService } from './general/services/tenant-config.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WebSocketsService } from './general/services/web-sockets/web-sockets.service';
import { UsersStoreService } from './general/services/users-store.service';
import { IconsComponent } from '@dispo-shared/shared-ui';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';
import { BuildInfoService } from './general/services/build-info/build-info.service';
import { ToastService } from './general/services/toast.service';

@Component({
  selector: 'xyz-web-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, IconsComponent],
})
export class AppComponent implements OnInit {
  private buildInfoService = inject(BuildInfoService);
  private toastService = inject(ToastService);

  private titleService = inject(Title);
  private tenantService = inject(TenantConfigService);
  private socketService = inject(WebSocketsService);
  private userStoreService = inject(UsersStoreService);
  private translateService = inject(TranslateService);
  private primeNGConfig = inject(PrimeNG);

  favIcon: HTMLLinkElement | null = document.querySelector('#appIcon');

  constructor() {
    // Set title
    this.titleService.setTitle('Tourfold | ' + this.tenantService.tenantMeta().name || '');

    // Set favicon
    if (this.favIcon) {
      if (this.tenantService.tenantConfig().favicon !== '') {
        this.favIcon.href = this.tenantService.tenantConfig().favicon;
      } else {
        this.favIcon.href = `./assets/img/favicons/tourfold.png`;
      }
    }

    // Set colors
    const colors = this.tenantService.tenantConfig().colors;
    for (const key in colors) {
      if (colors[key]) {
        document.documentElement.style.setProperty(key, colors[key]);
      }
    }

    // set connected status and store it storeService
    this.socketService.connectionSubject.pipe(takeUntilDestroyed()).subscribe((val) => {
      this.userStoreService.setConnected(val);
    });

    // Log build info to console
    console.log('Build id:', this.buildInfoService.buildId());

    // Watch for version changes and show notification (must be in constructor for injection context)
    effect(() => {
      const isNewVersion = this.buildInfoService.isNewVersionAvailable();
      if (isNewVersion) {
        this.showVersionUpdateNotification();
      }
    });
  }
  ngOnInit(): void {
    this.primeNGConfig.setTranslation({
      dayNames: this.translateService.instant('SHARED.DATE.WEEKDAYS'),
      dayNamesMin: this.translateService.instant('SHARED.DATE.WEEKDAYS_SHORT'),
      dayNamesShort: this.translateService.instant('SHARED.DATE.WEEKDAYS_SHORT'),
      monthNames: this.translateService.instant('SHARED.DATE.MONTHS'),
      monthNamesShort: this.translateService.instant('SHARED.DATE.MONTHS_SHORT'),
    });
  }

  private showVersionUpdateNotification(): void {
    
    
    // Show toast notification
    this.toastService.info(
      this.translateService.instant('NEW_VERSION_AVAILABLE.MESSAGE'),
      this.translateService.instant('NEW_VERSION_AVAILABLE.TITLE'),
      {
        timeOut: 10000, // 10 seconds
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-bottom-right',
        enableHtml: true
      }
    );

    // Acknowledge the update automatically after showing the toast
    this.buildInfoService.acknowledgeVersionUpdate();
  }
}
